import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { VendorDashboard } from "../vendorDashboard/VendorDashboard";
import { VendorList } from "../vendorDirectory/VendorList";
export const vendorTabTypes = {
    DASHBOARD: 0,
    DIRECTORY: 1,
    PROFILES: 2,
    FEEDBACK: 3,
}

export const vehicleTabslist = {
    [vendorTabTypes.DASHBOARD]: 'dashboard',
    [vendorTabTypes.DIRECTORY]: 'directory',
}

export const vehicleTabMapping = {
    'dashboard': vendorTabTypes.DASHBOARD,
    'directory': vendorTabTypes.DIRECTORY,
};

export const VendorManagementTabs = ({ }) => {
    const history = useHistory();
    //let { tab } = useParams();
    //const tabFromRoute = vehicleTabMapping[tab] || vendorTabTypes.DASHBOARD;
    const [selectedTab, setSelectedTab] = useState(vendorTabTypes.DASHBOARD);


    const vendorTabs = [
        {
            id: vendorTabTypes.DASHBOARD,
            label: 'Dashboard',
            component: <VendorDashboard />
        },
        {
            id: vendorTabTypes.DIRECTORY,
            label: 'Directory',
            component: <VendorList />
        }
    ]


    return (
        <TabsWrapper
            tabs={vendorTabs}
            setSelectedTab={setSelectedTab}
            selectedTab={selectedTab}
        />)
}